import axiosPost from '../axiosPost';

/**
 * @typedef {{
 * usuarioId:                 number
 * tipoDeDocumentoId:         number
 * tipoDeDocumentoCod:        string
 * usuarioNroDeDocumento:     number
 * usuarioApellidos:          string
 * usuarioNombres:            string
 * usuarioFechaDeNacimiento:  string
 * usuarioSexo:               string
 * usuarioPrimeraCompra:      string
 * usuarioTelefonoCelular:    string
 * usuarioMail:               string
 * usuarioVersion:            number
 * usuarioStatusOperativo:    string
 * imagePathPERFIL:           string
 * }} UsuarioBasico
 */

/** @returns {Promise<UsuarioBasico | undefined>} */
export const usuarioBasicosGet = async (arg) => {
    const { params } = arg

    const body = {
        "service": "UsuarioBasicosGet",
        "params": params ? params : {}
    }

    try {
        const result = await axiosPost('Y', body, arg);
        return result.data?.result?.[0];
    } catch (err) {
        console.log(err)
    }
};
